module.exports = __webpack_public_path__ + "img/theme-b.5f4ec560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme-b.png
// module id = s/+/
// module chunks = 1